export default __webpack_public_path__ + "i18n/translation-th.2c85a9e9.json";